import { cpfMask } from '@/app/utils/cpfFormater'
import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { useLoginFormController } from './useLoginFormController'
import { Link } from 'react-router-dom'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'
import { SupportRequestButton } from '@/view/components/SupportRequestButton'

export const LoginForm = () => {
  const { handleFormSubmit, isPending, methods, handleChangeWhitelabel } =
    useLoginFormController()
  const { appConfig } = useWhitelabelContext()

  const showCodeScreen = import.meta.env.VITE_CODE_SCREEN === 'true'

  return (
    <form
      onSubmit={methods.handleSubmit(handleFormSubmit)}
      className="flex w-80 flex-col gap-4 sm:w-96 md:w-[515px] lg:w-[480px]"
    >
      <BasicInput
        label="E-mail / CPF"
        name="email"
        type="text"
        className="mt-1 h-11 max-w-full border-[1px] border-black04 font-medium placeholder:text-black04"
        error={methods.formState.errors.email?.message}
        onInput={(e) =>
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          e.currentTarget.value.match(/^\d/) ? cpfMask(e as any) : undefined
        }
      />
      <BasicInput
        label="Senha"
        name="password"
        isPassword
        className="mt-1 h-11 max-w-full border-[1px] border-black04 font-medium placeholder:text-black04"
        error={methods.formState.errors.password?.message}
      />
      <div className="flex items-center justify-between">
        <p className="text-end text-sm text-black03">
          <Link to="/forgot-password">Esqueceu sua senha? </Link>
        </p>
      </div>
      <div>
        <Button
          type="submit"
          disabled={isPending}
          className="mt-4 h-14 w-full bg-primary text-lg font-bold text-white01 hover:bg-primary hover:brightness-150"
        >
          Entrar
        </Button>

        {appConfig?.CAN_REGISTER && (
          <Button
            variant="outline"
            className="mt-2 h-14 w-full border-primary text-lg font-bold text-primary hover:bg-primary hover:text-white"
            asChild
          >
            <Link to="/register">Cadastre-se</Link>
          </Button>
        )}

        {showCodeScreen && (
          <Button
            variant="ghost"
            className="w-full"
            type="button"
            onClick={() => handleChangeWhitelabel()}
          >
            Trocar parceiro
          </Button>
        )}

        <SupportRequestButton
          unauthenticated
          variant="text"
          className="mt-4 w-full"
        />
      </div>
    </form>
  )
}
